/**
 * Illegal Lashes — UGC video wall
 * Wires the per-video mute toggle and the prev/next scroll buttons.
 * Videos autoplay muted (required by browsers) only while their card is
 * on screen, so the carousel doesn't download/decode all clips at once;
 * tapping the icon unmutes just that clip. No dependency on jQuery.
 */
(function () {
  var ICON_MUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
  var ICON_UNMUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>';

  function setupPlaybackObserver(track) {
    if (!('IntersectionObserver' in window)) {
      track.querySelectorAll('video').forEach(function (video) { video.play().catch(function () {}); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { root: track, threshold: 0.6 });

    track.querySelectorAll('.il-ugc__card video').forEach(function (video) {
      observer.observe(video);
    });
  }

  function setup(root) {
    var track = root.querySelector('[data-role="track"]');
    var prev = root.querySelector('[data-role="prev"]');
    var next = root.querySelector('[data-role="next"]');
    if (!track) return;

    track.querySelectorAll('.il-ugc__card').forEach(function (card) {
      var video = card.querySelector('video');
      var muteBtn = card.querySelector('[data-role="mute"]');
      if (!video || !muteBtn) return;
      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        muteBtn.innerHTML = video.muted ? ICON_MUTED : ICON_UNMUTED;
        muteBtn.setAttribute('aria-label', video.muted ? 'Slå på ljud' : 'Stäng av ljud');
      });
    });

    setupPlaybackObserver(track);

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -240, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: 240, behavior: 'smooth' }); });
  }

  function init() {
    document.querySelectorAll('[data-il-ugc]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
